import { render, staticRenderFns } from "./ClassHistory.vue?vue&type=template&id=288c54ca&scoped=true&"
import script from "./ClassHistory.vue?vue&type=script&lang=js&"
export * from "./ClassHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c54ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Dan/code/teacher-helper/teacher-helper/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDivider,VToolbar})
